<shrd-uic-smartbar shrdUicFloating container=".hdms-main-mixed" [bottomed]="true" [hasPlaceholder]="false">
  <div class="smartbar-column-left">
    <div class="content-box content-box-tertiary-left">
      <a
        [attr.href]="'/'"
        shrdUicButton
        variant="tertiaryMinorBorderless"
        class="my-0 has-icon-only-sm-down"
        
      >
        <shrd-uic-svg-icon icon="arrow-left"></shrd-uic-svg-icon>
        <span class="visually-hidden-sm-down">{{ 'common.label.button.back' | i18next }}</span>
      </a>
    </div>
    <div class="content-box"></div>
  </div>
  <div class="smartbar-column-right mw-50">
    <div class="content-box"></div>
  </div>
</shrd-uic-smartbar>
